import { v4 as uuidv4 } from 'uuid'
import { ITime } from '../../api/citaPrevia'
import { CategoriaNeumatico, NeumaticoCAEPrice } from '../../types/Neumatico'
import { Promocion as PromocionBanner } from '../../components/promotionBanner/PromotionBanner'
import { SelectedTaller } from '../../types/Taller'
import { addProductToCesta, purgeCesta, reCalcCestaProducts, } from '../../utils/cestaLogic'
import { localStorage } from '../../utils/storage'
import * as Actions from '../actions/cestaActions'
import { LOGIN_OK, LOGOUT } from '../actions/userActions'
import moment from 'moment'
import { CategoriaCesta, TipoProductoCesta, } from '../../../shared/cesta/type/Cesta'
import {
  ENVIO_GR,
  ENVIO_MED,
  ENVIO_PEQ,
  MONTAJE_TALLER_BATERIA_ID,
  MONTAJE_TALLER_ID,
  RECOGIDA_TALLER_ACCESORIO_ID,
  RECOGIDA_TALLER_ACCESORIO_MOTO_ID,
  RECOGIDA_TALLER_ACEITE_ID,
} from '../sagas/cestaSagas'
import { CategoriaServicio } from '../../types/CategoriaServicio'
import { Vehicle } from '../../types/Vehiculo'
import { Revision } from '../../types/Revision'

export const version = 7
export const key = 'cestaData'

export interface Product {
  id_navision: string
  nombre_producto_es: string
  nombre_producto_ca: string
  nombre_producto_pt: string
  descripcion_es: string
  descripcion_pt: string
  descripcion_ca: string
  tipo_producto: TipoProductoCesta
  mas_info_es: string
  mas_info_ca: string
  mas_info_titulo_es: string
  mas_info_titulo_ca: string
  base_calculo: string
  cantidad: string
  precio: string
  impuesto: string
  descuento: string
  importe: number
  importeSinPromo: number
  promo: string
  ecotasa: string
  disponibilidad: number
  id_site_tipo_vehiculo: number | null
  runflat: number | null
  servicios: Service[]
  fechaEntrega: string
  comprobacionFechaEntrega: string
  codAlmacen: string
  codProveedor: string
  marcaje?: string
  matricula?: string
  marca: string
  clasificacion: CategoriaNeumatico
  promocion: Promocion
  promocionServicio?: Promocion | null
  banner: PromocionBanner | null
  categoria: CategoriaCesta
  importeSinImpuesto: number
  cae?: NeumaticoCAEPrice
}

export interface Promocion {
  id_site_promocion_cesta: number | null
  tipo:
    | 'individual-2aX'
    | 'individual-4x3'
    | 'individual-porcentaje'
    | 'individual-absoluto'
    | 'global-porcentaje'
    | 'global-absoluto'
    | 'seguro'
    | 'alineacion'
    | 'nitrogeno'
    | 'packinvierno'
    | 'kitur'
    | 'kit4x4'
    | 'kitcta'
    | 'montaje'
    | 'kitur-absoluto'
    | 'kit4x4-absoluto'
    | 'kitcta-absoluto'
    | 'montaje-porcentaje'
  importePromocion: number
  descripcion_es: string | null // erase these null, for now we leave due to branch incoherence
  descripcion_ca: string | null
  descripcion_pt: string | null
  importe_cupon: number
  fecha_limite: string
}

export interface Service {
  id_navision: string
  nombre_producto_es: string
  nombre_producto_ca: string
  descripcion_es: string
  descripcion_ca: string
  tipo_producto: 'servicio'
  mas_info_es: string
  mas_info_ca: string
  mas_info_titulo_es: string
  mas_info_titulo_ca: string
  base_calculo: 'U' | 'F'
  cantidad: number | string
  impuesto: string
  descuento: string
  importe: number
  ecotasa: number
  precio: string
  promo: string
  orden: number
  id_site_tipo_vehiculo: number
  obligatorio: number
  recomendado: number
  extra_servicio: number
  descuentoAsociado: string
  selected: boolean
  tipoProductoAsociado?: string
  categoriaServicio?: CategoriaServicio | null
  banner?: PromocionBanner | null
  categoria: CategoriaCesta
  promocion: Promocion
  importeSinImpuesto: number
}

export interface CestaDiscount {
  tipo: string | null
  importe_cupon: number
  descripcion_ca: string | null
  descripcion_es: string | null
  descripcion_pt: string | null
  codigo_promocion: string | null
  id_site_promocion_cesta: number
  tipo_producto: string | null
}

export const NULL_DISCOUNT: CestaDiscount = {
  tipo: null,
  importe_cupon: 0,
  descripcion_ca: null,
  descripcion_es: null,
  descripcion_pt: null,
  codigo_promocion: null,
  id_site_promocion_cesta: null,
  tipo_producto: null,
}

interface CuponError {
  message: 'NO_APPLY_CUPON' | 'UNEXISTING_CUPON'
  cupon: string
}

export enum CestaOrigin {
  Internal = 'internal',
  External = 'external',
}

type CestaOriginType = CestaOrigin.Internal | CestaOrigin.External

/** Totals com retorna `/cesta/update` i `retrieveCesta`; null mentre el client espera sincronització. */
export type CestaTotals = { totalProductos: number; total: number }

export const initialState = {
  _version: version,
  status: 'new' as 'new' | 'unloaded' | 'dirty' | 'ok',
  loading: false as boolean,
  cestaID: '' as string,
  totals: null as CestaTotals | null,
  products: [] as Product[],
  services: [] as Service[],
  codigoPostalIntroducido: '' as string,
  selectedTaller: {} as SelectedTaller,
  selectedDate: null as ITime,
  orderNumber: '' as string,
  matricula: null as string | null,
  step: 0,
  newVehicleData: null as Vehicle | null, // populated when a new user comes from revisiones or ac
  paymentType: null as 'total' | 'parcial' | null,
  error: null as string | null,
  generaFactura: false,
  cupones: [] as string[],
  cuponError: null as CuponError | null,
  displayCouponBox: true as boolean,
  discount: NULL_DISCOUNT,
  origin: CestaOrigin.Internal as CestaOriginType,
  searchToken: null as string | null,
  expressCheckinToken: '' as string,
  orderDetails: null as any,
  selectedRevision: {} as Revision,
  total: 0 as number, // TOTAL FINAL CON IVA
  totalProductos: 0 as number, // opcional (si el necessites)
  totalServicios: 0 as number,
  modificando: false as boolean, 
  minValidDate: null as Date | null,
  maxValidDate: null as Date | null,
  /** Obliga el pas Tallers (p. ex. sense cites o producte no disponible al taller). */
  forceTallerSelection: false as boolean,
}

export type CestaState = typeof initialState

export const createCesta = () => {
  const cestaID = uuidv4()
  localStorage.setItem(key, cestaID)
  return { ...initialState, cestaID }
}

export const reducer = (
  state: CestaState = initialState,
  action
): CestaState => {
  switch (action.type) {
    case LOGOUT:
      return createCesta()
    case Actions.INIT_CESTA:
      return createCesta()
    case Actions.SET_STEP:
      return {
        ...state,
        step: action.payload,
      }
    case Actions.REMOVE_PRODUCT_OK:
      // Keep last API totals until UPDATE_CESTA_OK; nulling forces a local
      // recalculo that can differ by cents from totals.total (e.g. 605.30 vs 605.29).
      return {
        ...state,
        products: action.payload.products,
        services: action.payload.services,
      }
    case Actions.UPDATE_QUANTITY: {
      const newProducts = state.products.map((p) =>
        p.id_navision === action.payload.id_navision
          ? {
              ...p,
              cantidad: action.payload.quantity,
            }
          : p
      )
      const newServices = [...state.services]
      reCalcCestaProducts(newProducts, newServices)
      return {
        ...state,
        products: newProducts,
        services: newServices,
      }
    }
    case Actions.CHECK_SERVICE:
      state.services = state.services.map((p) =>
        p.id_navision === action.payload.id_navision
          ? {
              ...p,
              selected: !p.selected,
            }
          : p
      )
      reCalcCestaProducts(state.products, state.services)
      return {
        ...state,
      }
    case Actions.SWITCH_SERVICE: {
      const newState = {
        ...state,
        products: state.products.map((product) => ({
          ...product,
          servicios: product.servicios.map((servicio) => ({
            ...servicio,
            selected:
              servicio.selected ||
              (servicio.categoriaServicio === CategoriaServicio.Montaje &&
              [
                MONTAJE_TALLER_ID,
                MONTAJE_TALLER_BATERIA_ID,
                RECOGIDA_TALLER_ACEITE_ID,
                RECOGIDA_TALLER_ACCESORIO_ID,
                RECOGIDA_TALLER_ACCESORIO_MOTO_ID,
                ENVIO_PEQ,
                ENVIO_MED,
                ENVIO_GR,
              ].includes(action.payload.id_navision)),
          })),
        })),
        services: state.services.map((service) => ({
          ...service,
          selected: service.id_navision === action.payload.id_navision,
        })),
      }
      reCalcCestaProducts(newState.products, newState.services)
      return newState
    }
    case Actions.ADD_PRODUCT_OK: {
      const { products, services, vehicle } = action.payload

      let newState = {
        loading: false,
        ...state,
        products: [...state.products],
        services: [...state.services],
      }

      if (vehicle) {
        // We allow only 1 Vehicle in cesta, so if we have info about another vehicle before
        // just remove all cesta
        if (
          newState.newVehicleData &&
          newState.newVehicleData.cod_matricula !== vehicle.cod_matricula
        ) {
          newState = { ...createCesta(), products: [], services: [] }
        }
        // Then set data of new vehicle in cestaState
        newState = {
          ...newState,
          newVehicleData: vehicle,
          matricula: vehicle.cod_matricula,
        }
      }

      if (products.length === 1) {
        newState = purgeCesta(newState, products[0])
      }

      addProductToCesta(newState, products, services)
      // Keep last API totals until UPDATE_CESTA_OK refreshes them.
      return newState
    }
    case Actions.ADD_PRODUCT:
    case Actions.UPDATE_CESTA:
    case Actions.LOAD_CESTA:
      return {
        ...state,
        loading: true,
      }
    case Actions.UPDATE_CESTA_OK: {
      const { payload } = action
      return {
        ...state,
        loading: false,
        totals:
          payload.totals !== undefined ? payload.totals : state.totals,
        products: [...payload.products],
        services: [...payload.services],
        cupones: payload.cupones,
        cuponError: payload.cuponError,
        displayCouponBox: payload.displayCouponBox,
        generaFactura: payload.generaFactura,
        discount: payload.discount,
      }
    }
    case Actions.LOAD_CESTA_OK:
      return {
        ...state,
        loading: false,
        status: 'ok',
        totals:
          action.payload.totals !== undefined
            ? action.payload.totals
            : state.totals,
        discount: { ...action.payload.discount },
        products: action.payload.products,
        services: action.payload.services,
        generaFactura: action.payload.generaFactura,
        newVehicleData: action.payload.newVehicleData,
      }
    case LOGIN_OK: {
      if (!action.payload.cesta) {
        return state
      }
      const cestaID = action.payload.cesta.cestaID || state.cestaID
      localStorage.setItem(key, cestaID)
      return {
        ...state,
        ...action.payload.cesta,
        cestaID,
        totals: action.payload.cesta?.totals ?? null,
      }
    }
    case Actions.ADD_CESTA_SELECTED_TIME_FAILED:
    case Actions.ADD_PRODUCT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case Actions.LOAD_CESTA_FAILED:
      // Show error? We start anew...
      return createCesta()
    case Actions.ADD_CESTA_SELECTED_TALLER:
      return {
        ...state,
        selectedTaller: { ...action.payload.selectedTaller },
        codigoPostalIntroducido:
          state.codigoPostalIntroducido ||
          action.payload.selectedTaller.cpostal,
        forceTallerSelection: false,
      }
    case Actions.UPDATE_SELECTED_TALLER_AVAILABILITY:
      if (!state.selectedTaller) {
        return state
      }
      return {
        ...state,
        selectedTaller: {
          ...state.selectedTaller,
          availabilityDate: action.payload.availabilityDate,
        },
      }
    case Actions.ADD_CESTA_SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.payload.selectedDate,
      }
    case Actions.ADD_CESTA_SELECTED_CP:
      return {
        ...state,
        codigoPostalIntroducido: action.payload.cp,
      }
    case Actions.UPDATE_PRODUCT:
    case Actions.ADD_CESTA_SELECTED_TIME: {
      /* const { selectedProducts } = action.payload
      const selectedProductsMap = selectedProducts.reduce(
        (product) => ([product.id_navision] = product),
        {}
      )
      const products = state.products.map((product) => {
        const sp = selectedProductsMap[product.id_navision]
        return sp
          ? {
              ...product,
              codAlmacen: sp.codAlmacen,
              codProveedor: sp.codProveedor,
              fechaEntrega: sp.fechaEntrega,
              comprobacionFechaEntrega: moment().format('DD-MM-YYYY'),
            }
          : product
      })
      return {
        ...state,
        products,
        loading: true,
      } */
      const { selectedProducts } = action.payload
      const newProducts = state.products.map((product) => {
        const sp = selectedProducts.find(
          (sps) => sps.id_navision === product.id_navision
        )
        if (sp) {
          product.codAlmacen = sp.codAlmacen
          product.codProveedor = sp.codProveedor
          product.fechaEntrega = sp.fechaEntrega
          product.comprobacionFechaEntrega = moment().format('DD-MM-YYYY')
        }
        return product
      })
      return {
        ...state,
        products: newProducts,
        loading: true,
      }
    }
    case Actions.ADD_CESTA_SELECTED_TIME_OK:
      return {
        ...state,
        loading: false,
      }
    case Actions.ADD_CESTA_ORDER_NUMBER:
      return {
        ...state,
        orderNumber: action.payload.orderNumber,
        expressCheckinToken: action.payload.expressCheckinToken,
        orderDetails: action.payload.orderDetails,
      }
    case Actions.ADD_NEWVEHICLE_DATA:
      return {
        ...state,
        newVehicleData: action.payload.newVehicleData,
      }
    case Actions.ADD_MATRICULA:
      return {
        ...state,
        matricula: action.payload.matricula,
      }
    case Actions.ADD_CODIGO_PROMOCION:
      return {
        ...state,
        cupones: [
          ...new Set([...state.cupones, action.payload.codigo_promocion]),
        ],
        discount: {
          ...state.discount,
        },
      }
    case Actions.ADD_PAYMENT_TYPE:
      return {
        ...state,
        paymentType: action.payload.paymentType,
      }
    case Actions.RESET_ERROR:
      return {
        ...state,
        error: null,
      }

    case Actions.RESET_CESTA:
      return {
        ...createCesta(),
        error: null,
      }
    case Actions.ADD_SEARCH_TOKEN:
      return {
        ...state,
        searchToken: action.payload.token,
      }
    case Actions.ADD_CESTA_SELECTED_REVISION:
      return {
        ...state,
        selectedRevision: { ...action.payload.selectedRevision },
      }
    case Actions.REMOVE_CESTA_SELECTED_REVISION:
      return {
        ...state,
        selectedRevision: null,
      }
    case Actions.RESET_CESTA_TALLER:
      return {
        ...state,
        selectedTaller: initialState.selectedTaller,
        modificando: false,
        forceTallerSelection: true,
      }
    case Actions.SET_FORCE_TALLER_SELECTION:
      return {
        ...state,
        forceTallerSelection: action.payload,
      }
    case Actions.RETRIEVE_PEDIDO_INFO:
      return {
        ...state,
        loading: true,
        error: null,
        modificando: false, 
      }
    case Actions.RETRIEVE_PEDIDO_INFO_OK:
      return {
        ...state,
        ...action.payload,
        loading: false,
        modificando: true, 
      }
    case Actions.RETRIEVE_PEDIDO_INFO_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        modificando: false, 
      }
    case Actions.TOGGLE_PRODUCT_SERVICE: {
      const { productId, serviceId, selected } = action.payload

      const newProducts = state.products.map((product) =>
        product.id_navision !== productId
          ? product
          : {
              ...product,
              servicios: product.servicios.map((service) =>
                service.id_navision === serviceId
                  ? { ...service, selected }
                  : service
              ),
            }
      )

      reCalcCestaProducts(newProducts, state.services)

      return {
        ...state,
        products: newProducts,
      }
    }

    default:
      return state
  }
}
